import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Link } from 'react-router-dom';
import AuthFormButton from './/AuthFormButton';
import SignInInputWithLabel from './SignInInputWithLabel';
import { SIGN_IN } from '../../redux/authReducer';
import AuthFormContainer from './AuthFormContainer';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const SignInForm = ({ signIn, signInError, t, }) => {
  const classes = useStyles();
  const [formFields, setFromFields] = useState({});
  const onFieldChange = (value, filedName) => {
    setFromFields({ ...formFields, [filedName]: value, });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    signIn(formFields);
  };
  return (
    <AuthFormContainer >
      <form className={classes.SignInForm} onSubmit={handleSubmit}>
        <SignInInputWithLabel
          labelText={t('email')}
          filedName="email"
          onChange={onFieldChange}
          value={formFields.email}
          error={signInError}
          errorMessage={t('invalid_credentials')}
        />
        <SignInInputWithLabel
          labelText={t('password')}
          filedName="password"
          type="password"
          onChange={onFieldChange}
          value={formFields.password}
          error={signInError}
          errorMessage={t('invalid_credentials')}
        />
        <Link
          to="/dashboard/auth/new-password"
          className={classes.formTrouble}
        >
          {t('sign_in_troubles')}
        </Link>
        <AuthFormButton text={t('singIn')} />
      </form>
    </AuthFormContainer>
  );
};

SignInForm.propTypes = {
  t: PropTypes.func.isRequired,
  signIn: PropTypes.func.isRequired,
  signInError: PropTypes.bool.isRequired,
};

const useStyles = createUseStyles({
  SignInForm: {
    fontSize: '13px',
    fontWeight: '700',
    color: '#b0acb7',
    marginTop: '2.5em',
    textAlign: 'left',
  },
  formTrouble: {
    textDecoration: 'none',
    color: '#57c2ef',
    fontWeight: '700',
    fontSize: '14px',
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (data) => dispatch(SIGN_IN(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    signInError: state.authReducer.signInError,
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withScopedTranslations('signIn'))(SignInForm);

